import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, LogOut } from "lucide-react";
import { ANNEXURES } from "../shared/annexures";
import AnnexureTable from "../components/AnnexureTable";
import { clearSession, getUser } from "../shared/api";

export default function Dashboard() {
    const navigate = useNavigate();
    const [active, setActive] = useState("b");
    const user = getUser();
    const annexure = ANNEXURES[active];

    const logout = () => {
        clearSession();
        navigate("/", { replace: true });
    };

    const navClass = (key) =>
        `flex items-center gap-3 rounded-lg px-4 py-2.5 text-sm font-medium transition ${
            active === key ? "bg-rose-600 text-white" : "text-white/70 hover:bg-white/10 hover:text-white"
        }`;

    return (
        <div className="flex min-h-screen">
            <aside className="hidden md:flex w-64 flex-col bg-neutral-950 shadow-xl h-screen sticky top-0">
                <div className="flex h-16 items-center px-6 border-b border-white/10">
                    <img src="/mavx.svg" alt="MavX" className="h-8 w-auto" />
                </div>
                <nav className="flex flex-col gap-1 p-4 flex-1">
                    {Object.values(ANNEXURES).map((a) => (
                        <button key={a.key} onClick={() => setActive(a.key)} className={navClass(a.key)}>
                            <FileText size={20} /> {a.tab}
                        </button>
                    ))}
                </nav>
                <div className="p-4 border-t border-white/10">
                    <button onClick={logout}
                        className="flex w-full items-center gap-3 rounded-lg px-4 py-2.5 text-sm font-medium text-white/70 hover:bg-white/10 hover:text-white transition">
                        <LogOut size={20} /> Logout
                    </button>
                </div>
            </aside>

            <div className="flex flex-1 flex-col min-w-0">
                <header className="flex h-16 items-center justify-between bg-white px-4 md:px-8 shadow-sm border-b border-gray-200 sticky top-0 z-10">
                    <div className="flex items-center gap-3">
                        <img src="/mavx.svg" alt="MavX" className="h-7 w-auto md:hidden bg-neutral-950 rounded px-1.5 py-1" />
                        <h1 className="text-lg font-semibold text-gray-800">{annexure.tab}</h1>
                    </div>
                    <div className="flex items-center gap-4">
                        {user?.name && <span className="text-sm text-gray-500">{user.name}</span>}
                        <button onClick={logout} className="md:hidden text-gray-500 hover:text-rose-600 transition" title="Logout">
                            <LogOut size={20} />
                        </button>
                    </div>
                </header>

                <div className="md:hidden flex gap-2 bg-white px-4 py-2 border-b border-gray-200">
                    {Object.values(ANNEXURES).map((a) => (
                        <button key={a.key} onClick={() => setActive(a.key)}
                            className={`flex-1 rounded-lg px-4 py-2 text-sm font-medium transition ${
                                active === a.key ? "bg-rose-600 text-white" : "text-gray-600 hover:bg-gray-100"
                            }`}>
                            {a.tab}
                        </button>
                    ))}
                </div>

                <main className="flex-1 p-4 md:p-8">
                    <AnnexureTable key={active} annexure={annexure} />
                </main>
            </div>
        </div>
    );
}
